import React from 'react';
import './form-actions.css';
export const FORM_ACTIONS=[
 ['reset_form','Reset form'],['clear_field','Clear a field'],['scroll_to_field','Jump to a field'],
 ['submit_form','Submit form'],['go_to_top','Back to top'],['print_form','Print form'],
 ['copy_link','Copy form link'],['open_url','Open a page'],['show_invoices','Choose invoices']
].map(([value,label])=>({value,label}));
export function SlimActionButton({definition,onAction,disabled=false}){
 const text=definition.label||FORM_ACTIONS.find(a=>a.value===definition.action)?.label||'Action';
 return <button type="button" className="hsf-action-slim" aria-label={text} disabled={disabled} onClick={event=>{event.preventDefault();event.stopPropagation();onAction?.(definition,event)}}>{text}</button>;
}
